<template>
  
  <div class="container">
  
    <Cabecera></Cabecera>
    <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/RegistroBitaroca">Registro de Bitácora</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <div>
  <Menu/>
    
  <b-card>
    
   <br>

        
          <span class="card-title">Registro de Bitácora General</span>
          <form id="formPeso" autocomplete="off" @submit.prevent="editar" enctype="multipart/form-data">
            <input type="text" placeholder="Unidad" :value=unidad required disabled>
             <input type="date" name="fecharegistro" id="fecharegistro" placeholder="Fecha" v-on:click=usuario() required>
             <input type="text" name="tipo" id="tipo" placeholder="Tipo" required>
             <input type="text" name="departamento" id="departamento" placeholder="Departamento" required>
             <input type="text" name="ubicacion" id="ubicacion" placeholder="Ubicación" required>
             <input type="text" name="descripcion" id="descripcion" placeholder="Descripción" required>
             <b-form-textarea
      id="personal"
      name="personal"
      v-model="personalForma"
      placeholder="Personal"
      rows="3"
      max-rows="6"
    ></b-form-textarea>
    <b-form-textarea
    id="materiales"
      name="materiales"
      v-model="materialesForma"
      placeholder="Materiales"
      rows="3"
      max-rows="6"
    ></b-form-textarea>
            <input type="text" name="resultado" id="resultado" placeholder="Resultado" required>
            
            <input type="text" name="etiqueta" id="etiqueta" placeholder="Etiquetas">
          <b-form-textarea
    id="comentario"
      name="comentario"
      v-model="comentarioForma"
      placeholder="Comentarios"
      rows="3"
      max-rows="6"
    ></b-form-textarea>

            <div class="file-field input-field">
                <div class="btn">
                <span>Foto Antes 1</span>
                <input type="file" name="fotoantes1">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text">
                </div>
            </div>

            <div class="file-field input-field">
                <div class="btn">
                <span>Foto antes 2</span>
                <input type="file" name="fotoantes2">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text">
                </div>
            </div>
            
            <div class="file-field input-field">
                <div class="btn">
                <span>Foto después 1</span>
                <input type="file" name="fotodespues1">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text">
                </div>
            </div>

            <div class="file-field input-field">
                <div class="btn">
                <span>Foto después 2</span>
                <input type="file" name="fotodespues2">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text">
                </div>
            </div>
             
             <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
             <input type="hidden" name="idForma" id="idForma" :value=idActual>
             <input type="hidden" name="unidadForma" id="unidadForma" :value=unidad>
             <input type="hidden" name="fotoForma" id="fotoForma" :value=fotoActual>

             <input type="hidden" name="materialhidden" id="materialhidden" :value=materialesForma>
             <input type="hidden" name="comentariohidden" id="comentariohidden" :value=comentarioForma>
             <input type="hidden" name="personalhidden" id="personalhidden" :value=personalForma>

           
<div class="card-action">
                        <h6 style="color:Tomato;font-weight:bold;">{{corregir}}</h6>
                        <input type="submit" value="Registrar" :class="boton">
                           
        </div>
            </form>
       

    <b-card-body class="text-center">
     

      <b-card-text>
       <div>
    <h5>Listado de Bitácora <br>
    <b-button variant="primary" v-on:click=ajax()>ACTUALIZAR</b-button>
<p id="datetime"></p>
    </h5>
   <vue-good-table
   :columns="columns"
     :rows="rows"
     :line-numbers="true"
     @on-cell-click="onCellClick"
     
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:350,
       position:'top',
       perPageDropdown:[10,50,100],
       nextLabel:'Siguiente',
       PrevLabel:'Anterior',
       rowsPerPageLabel:'Filas por página',
       ofLabel:'de'
     }"
     :search-options="{
       enabled:true,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">
          
    <span v-if="props.column.field == 'eliminar'&&props.formattedRow['capturista']==usuariolocal">
       
       <b-button variant='danger'>Eliminar</b-button>
     
    </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
  </template>
   </vue-good-table>
</div>
      </b-card-text>

      
    </b-card-body>
  </b-card>
</div>

    
  </div>
</template>

<script>
import Cabecera from './Cabecera' //v-on:keyup.enter="onEnter"
import Menu from './Menu'
import axios from 'axios'
import swal from 'sweetalert'
import sesion from '../mixins/sesion'

import eliminarBitacora from '../mixins/eliminarBitacora'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
  name: 'RegistroBitacora',  
  data () {
    return {
        value:1,
         boton:'btn blue',
      msg: 'Número de arete',
      usuariolocal:'',
      fotolocal:'',
      unidad:'',
        fecha1:'',
        fecha2:'',
        corregir:'',
        canal:'',
        serie:'',
        materialesForma:'',
        comentarioForma:'',
        personalForma:'',
      columns:[
        {
          label:'id',
          field:'id',
            hidden:true
        },
        {
          label:'capturista',
          field:'capturista',
            hidden:true
        },
        {
          label:'Identificador',
          field:'identificador',
         },
        {
          label:'Fecha',
          field:'fecha',
          type:'date',
          dateInputFormat:'yyyy-mm-dd',
          dateOutputFormat:'yyyy-mm-dd'
        },
        {
          label:'Ubicación',
          field:'ubicacion'
        },
        {
          label:'Tipo',
          field:'tipo'
        },
        {
          label:'Departamento',
          field:'departamento'
        },
        {
          label:'Eliminar',
          field:'eliminar'
        },
      ],
      rows:[

      ]
    }
  },
  computed:{
     ...mapState(['usuarioActual','idActual','fotoActual'])
  },
  methods:{
    validarCanal(){
            
                const formData = new FormData()
                formData.append('serie',this.serie)
                formData.append('unidadForma',this.unidad)
                formData.append('canal',this.value)
               /* EN caso de querer mandar más de un dato se repite varias veces y se cambia el nombre y la variable
                FormData.append('correo',this.correo)
                FormData.append('correo',this.correo)*/
                //axios.post('httpss://proyectocdnywebpack.000webhostapp.com/snippetWebpack/api/loginRegistro/validarEmail.php',formData)
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/validarCanal.php',formData)
                    .then(res=>{
                        this.respuesta = res.data
                        if (res.data =='success') {
                            this.boton = 'btn blue'
                            this.corregir=''
                        } else {
                            this.boton = 'btn blue disabled'
                            this.corregir='El canal indicado ya está registrado'
                            swal({
                    title:'El canal indicado ya está registrado',
                    icon: 'error'}) 
                        }
                    })
    },
    getId(){
           this.usuario()

            const id = document.getElementById("usuarioForma").value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPerfilUsuario.php?id='+ id)
            
                .then(response=>{
                   
                    this.unidad = response.data.unidad
                  
                    
                })
                   
        },

     onCellClick(params) {
         if(params.column.field=="eliminar"){
         this.eliminarBitacora(params.row.id)
         setTimeout(() => {  this.ajax(); }, 3500)
         }
        this.ajax()
         //
   // alert (params.row.id) // params.row - row object   /// 
    // params.pageIndex - index of this row on the current page.
    // params.selected - if selection is enabled this argument 
    // indicates selected or not
    // params.event - click event
  },
      /*onEnter: function() {
      swal("Mensaje de enter")
    },*/
    fecha(){
        var dt = new Date();
    document.getElementById("datetime").innerHTML = ((dt.getFullYear() +"-"+ (("0"+(dt.getMonth()+1)).slice(-2)) 
    +"-"+ ("0"+dt.getDate()).slice(-2)));
    },
    ajaxdelay(){
     setTimeout(() => {  this.ajax(); }, 2500)
    },
    ajax(){
      this.getId()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     const fecha = '2020-02-02'
     const unidadquery=this.unidad
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getBitacora.php?fecha='+fecha+'&unidad='+unidadquery)
      .then(response=>{
        this.rows=response.data
      })

    },
    usuario(){
        this.fecha()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     this.usuariolocal= result
     const tok=this.usuariolocal
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
       
        this.usuariolocal=response.data.email
        this.unidad=response.data.unidad
        this.perfil=response.data.perfil
      })

    },
    ticketIncremento(){
       // document.getElementById('canal').value=document.getElementById('canal').value++
    this.value=Number(this.value)+1
    this.validarCanal()
    },
    editar(event){
      if(this.boton == 'btn blue disabled'){

            }
            else{
            //this.usuario()
             const form=document.getElementById('formPeso')
             //formData.append('reemo',this.QRForma)
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/registrarBitacora.php',new FormData(form))
                .then(res=>{
                    
                    if (res.data == 'success') {
                    
                       swal('El registro fue editado')
                        setTimeout(() => {  event.target.reset() }, 500)
                         
                        //this.$router.push('/inicio')
                        
                    } else {
                        swal('El registro no pudo ser editado'+res.data)
                    }
                })
            }
        },
        direccionamiento(){
            if (this.respuesta=='success') {
                this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar',
                    icon: 'error'})  
            }
        },
  },
  created(){
    this.ajax()
    this.usuario()
  },
  components:{
    Cabecera,
    Menu
  },
  mixins:[sesion,eliminarBitacora]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RegistroBitacora.vue